import { atom } from "jotai";

import { NEED_HYDRATION } from "~/_constants";

const daoSubdomainAtom = atom<string | null | typeof NEED_HYDRATION>(
  NEED_HYDRATION,
);
export { daoSubdomainAtom };
